// noinspection JSUnusedGlobalSymbols

export enum ContactType {
  TECHNICAL_CONTACT = 'TECHNICAL_CONTACT',
  BUSINESS_SPONSOR = 'BUSINESS_SPONSOR',
  TRAINER = 'TRAINER'
}
